import React from 'react';
import './footer.css'
import pic29 from '../../assets/pic29.png'
import pic30 from '../../assets/pic30.png'
import pic31 from '../../assets/pic31.png'
import pic32 from '../../assets/pic32.png'
import pic33 from '../../assets/pic33.png'
import Listfooter from '../common/listfooter';
import List2footer from '../common/list2-footer';
import CTAsec6 from '../common/cta-sec6';
import { useTranslation } from 'react-i18next';
import pic37 from '../../assets/pic37.png'

const Footer = () => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

const isArabic = i18n.language === 'ar';
    return ( 
        <footer className='footer' dir={direction}>
            <nav className='footer-cont'>
                <nav className='footer-cont2'>
                    <nav className='top-part-footer'>
                        <article className='left-box-footer'>
                                <img className='logo-footer' src={isArabic ? pic37 : pic29} alt='logo'></img>
                               <p className='para-footer'>{t('Your ultimate destination for discovering and booking tickets to the best music events around the world.')}</p>
                               <nav className='icons-list'>
                                <img src={pic30} alt='socialmedia'></img>
                                <img src={pic31} alt='socialmedia'></img>
                                <img src={pic32} alt='socialmedia'></img>
                                <img src={pic33} alt='socialmedia'></img>
                               </nav>
                        </article>

                        <nav className='right-part-footer' >
                            <Listfooter title={t('Quick Links')} />
                            <List2footer title={t('Contact Us')}/>

                        </nav>  
                    </nav>

                    <nav className='subscribe-cont'>
                        <h2 className='title-newspaper'>{t('Subscribe to our Newsletter')}</h2>
                        <form className='form-footer'>
                            <input className='input-footer' placeholder={t('Enter your email')}/>
                            <button className='cta-container-footer'>
                                <CTAsec6 title={t('Submit')}/>
                            </button>
                        </form>
                    </nav>
                </nav>

                <article className='footer-last-part-cont'>
                        <h5 className='small-text-footer'>{t('© 2026 MusicTicket. All rights reserved.')}</h5>
                </article>


            </nav>
        </footer>
     );
}
 
export default Footer;